import { Image } from 'antd'
import { isImage } from 'general_function'
import React from 'react'
import { FileOutlined } from "@ant-design/icons"

export default function ShowFiles({ files }) {
    return <>
        {files.length > 0 && (
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    marginTop: "10px",
                    gap: "10px",
                }}
            >
                {files.filter(({ file }) => isImage(file)).map(
                    ({ id, file }) =>
                        <Image
                            key={id}
                            preview={true}
                            src={file}
                            width={200}
                        />
                )}
            </div>
        )
        }
        {files.filter(({ file }) => !isImage(file)).map(({ id, file }) => <div key={id}>
            <a key={id} href={file} target="_blank" rel="noreferrer"><FileOutlined /> {file.split('/').pop()}</a>
        </div>)}
    </>
}
